import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
let i = 0,k =1;
@Component({
  selector: 'app-manage-invoice',
  templateUrl: './manage-invoice.component.html',
  styleUrls: ['./manage-invoice.component.scss'],
})
export class ManageInvoiceComponent {
  constructor(private service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public auth: AuthService,
    private bottomSheet: MatBottomSheet) { }

  customer: boolean = true;
  shift: boolean; 
  invoices: any=[];
  invoiceType;
  statusType;
  close:boolean = false;
  changed: boolean = true;
  loader: boolean = false;
  menu: boolean = false;
  dateFormat;
  clicked:boolean=false;
  search; 
  orgs: any;
  orgId = localStorage.getItem('organizationId');
  orgName;
  filterPop: boolean = false;
  filterDate;
  curntDate = new Date();
  cDate;
  pDate;
  calender: boolean = false;
  date;
  tDate;
  payment : any =[{name :'All', id:1},{name :'Pending', id:2},{name :'Paid', id:3},];
  paymentId;
  paymentName='Select';
  serviceRequests;
  orgbase: boolean;
  cloneUsers:any=[];
  userData;
  custName;
  id;
  dubTrackObj:any=[];

  ionViewWillEnter() {
    this.clicked=false;
    i=0;
    this.shift=true;
    this.dateFormat = this.auth.getDateformat();
    this.orgs = JSON.parse(localStorage.getItem('capabilityOrg'));
    this.orgId = this.orgs[0].id;
    sessionStorage.setItem('orgId',this.orgId)
    this.orgName = this.orgs[0].code;
    let pDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
    this.cDate = this.returnDate(this.curntDate);
    this.pDate = this.returnDate(pDate);
    setTimeout(() => {
      this.getInvoices();
    }, 500);

    if(this.auth.getOrgCapabilities(this.orgId,'SP')){
      this.orgbase = false; 
    }
  }

  refreshData(event){
    this.loader = true; 
    this.ionViewWillEnter();
    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }

  change() {
    this.customer = !this.customer;
    this.menu = !this.menu
    this.getInvoices();
  }
  change1() {
    this.changed = !this.changed;
    this.getInvoices();
  }
  getInvoices() {
    this.loader = true;
    this.calender = false;
    if (this.customer){     
      this.fetchInvoiceByWeek(1,0)
    }
    
    else {
      if (this.changed){    
        this.fetchInvoiceByWeek(2,1) 
      }
      else{this.fetchInvoiceByWeek(3,1);   
      }
        
    }
  }
  getInvoicesByDate() {
    this.loader = true;
    if (this.customer)
      this.fetchInvoiceByDate(1,0)
    else {
      if (this.changed)
        this.fetchInvoiceByDate(2,1)
      else
        this.fetchInvoiceByDate(3,1)
    }
  }
  route(id) {
         this.router.navigateByUrl('detailInvoice/' + id)    
  }
  cancelFilter(){
    this.filterPop = false;
  }
  openBottomSheetstatus(): void{
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.payment,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.paymentName = res.name;
      this.filterPop=false;
      this.loader=true;
        if(this.calender)
      this.fetchInvoiceByDate(2,res.id)
      else
      this.fetchInvoiceByWeek(2,res.id)
        });
  }
  generate(){
    this.loader = true;
      let fromDate = this.tDate.begin;
      let toDate: any = this.tDate.end;
      let todate = this.returnDate(fromDate);
      let frdate = this.returnDate(toDate);
      let tDate = todate + ' ' + '00:00:00'
      let fDate = frdate + ' ' + '00:00:00'
    this.service.generateInvoiceByDate(tDate,fDate).subscribe((res: any) => {
      this.handler.res("Invoice Generated Successfully")
    this.loader = false;
  },err => {
    this.loader = false;
    this.handler.err(err);
   })
  }


  openBottomSheet(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.orgs,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.orgName = res.code;
      this.orgId = res.id;
      this.orgbase=true;
      sessionStorage.setItem('orgId',this.orgId)
      this.getInvoices();
      this.plusButton(res.capabilities);
    });
  }

  plusButton(data){
    data.map(res=>{
      if(res.code=="SP"){
       this.orgbase=false}
    })
  }

  fetchInvoiceByWeek(type,status) {
    k=1;
    this.invoiceType=type;
    this.statusType=status;
    let toDate = this.cDate+' '+'23:59:59';
    let fromDate = this.pDate+' '+'00:00:00';
    this.service.getInvoiceByDateBypage(this.orgId, fromDate, toDate,type,k).subscribe((res: any) => {
      this.invoices = [];
      if (res) {
        if(status==0)
        this.invoices=res;
        else if(status==2)
        this.invoices = res.filter(dat=>dat.paymentStatus==1);      
        else if(status==3)
        this.invoices = res.filter(dat=>dat.paymentStatus==2);
        else
        this.invoices = res.filter(dat=>dat.paymentStatus==1 || dat.paymentStatus==2 );
 
        if(this.customer){
         this.invoices.map(res =>{
          if(res.serviceRequests.length > 0){
            if(res.serviceRequests[0].providerService){
            Object.assign(res, { custfname: res.serviceRequests[0].requestor.firstName,custId: res.serviceRequests[0].requestor.userId,
            custlname: res.serviceRequests[0].requestor. lastName, name: res.serviceRequests[0].providerService.name})
            }
          }  
         }) 
        }else{
          this.invoices.map(res => Object.assign(res, { name: res.contractor.firstName}))
                }
         k++;
         this.dubTrackObj = this.invoices
        this.loader=false;
      }
      else {
        this.loader = false;
        this.handler.res("No Invoices For You")
      }
    }, err => {
      this.loader = false;
      this.handler.err(err);
    })

  }
  fetchInvoiceByDate(type,status) {
    this.invoiceType=type;
    this.statusType=status;
    this.calender = true;
    let fromDate = this.returnDate(this.filterDate.begin)+' '+'00:00:00';
    let toDate = this.returnDate(this.filterDate.end)+' '+'23:59:59';
    this.service.getInvoiceByDate(this.orgId, fromDate, toDate,type).subscribe((res: any) => {
      this.invoices = [];
      if (res) {
        if(status==0)
        this.invoices=res;
        else if(status==2)
        this.invoices = res.filter(dat=>dat.paymentStatus==1);
        else if(status==3){
        this.invoices = res.filter(dat=>dat.paymentStatus==2);
        }
        else
        this.invoices = res.filter(dat=>dat.paymentStatus==1 || dat.paymentStatus==2 );
    
        if(this.customer){
          this.invoices.map(res =>{
           if(res.serviceRequests.length > 0){
            if(res.serviceRequests[0].providerService){
             Object.assign(res, {  custfname: res.serviceRequests[0].requestor.firstName,custId: res.serviceRequests[0].requestor.userId,
             custlname: res.serviceRequests[0].requestor.lastName,name: res.serviceRequests[0].providerService.name})
            }
           }  
          }) 
         }else{
           this.invoices.map(res => Object.assign(res, { name: res.contractor.firstName}))
        
         }
        this.loader=false;
      }
      else {
        this.loader = false;
        this.handler.res("No Invoices For You")
      }
    }, err => {
      this.loader = false;
      this.handler.err(err);
    })

  }


  returnDate(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
    let month = data.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let year = data.getFullYear();
    return year + '-' + month + '-' + date;
  }

  filterReq(){
    this.filterPop = true;
  }

  splitvalue(data){
    if(data.includes('-')){
      let y =data.slice(1)
      return y;
    } else{
      return data;
    }
  }
  routeTo(){
    this.router.navigateByUrl("/settlement-invoice")
    this.clicked=true;
  }
  ionViewWillLeave(){
    if(!this.clicked)
    sessionStorage.clear()
    this.custName = "";
    this.close = false;
  }

  clear(){
    this.custName="";
    this.close = false;
    this.ionViewWillEnter();
  }

  
  invoiceBypage($event){
    if(this.custName == "" || this.custName == undefined){
   let toDate = this.cDate+' '+'23:59:59';
   let fromDate = this.pDate+' '+'00:00:00';
   this.service.getInvoiceByDateBypage(this.orgId, fromDate, toDate,this.invoiceType,k).subscribe((res: any) => {
    if (res) {
      if(this.statusType==0)
      res.map(dat=>{
        this.invoices.push(dat)
      })
      else if(this.statusType==2)
      this.invoices = res.filter(dat=>dat.paymentStatus==1);      
      else if(this.statusType==3)
      this.invoices = res.filter(dat=>dat.paymentStatus==2);
      else
      this.invoices = res.filter(dat=>dat.paymentStatus==1 || dat.paymentStatus==2 );

      if(this.customer){
       this.invoices.map(res =>{
        if(res.serviceRequests.length > 0){
          if(res.serviceRequests[0].providerService){
          Object.assign(res, { custfname: res.serviceRequests[0].requestor.firstName,custId: res.serviceRequests[0].requestor.userId,
          custlname: res.serviceRequests[0].requestor. lastName, name: res.serviceRequests[0].providerService.name})
          }
        }  
       }) 
      }else{
        this.invoices.map(res => Object.assign(res, { name: res.contractor.firstName}))
              }
      setTimeout(() => {
        this.dubTrackObj = this.invoices; 
      }, 1500);
            
       k++;
      this.loader=false;
    }
    else {
      this.loader = false;
      this.handler.res("No Invoices For You")
    }
  }, err => {
    this.loader = false;
  })
 }
  }

  searchUser(val) {    
    var num1 = /^[0-9]+$/
    if(this.custName.match(num1)){
    let x = val.length;
    this.close=true;
    this.id=localStorage.getItem('organizationId');
    var toDate = this.cDate+' '+'23:59:59';
    var fromDate = this.pDate+' '+'00:00:00'; 
    if(x > 0){
      this.invoices = [];
     this.service.searchInvoiceById(this.id,val,fromDate,toDate).subscribe((res: any) => {
       if(res != null && res != "NO_CONTENT" && res.length > 0){  
        this.invoices =JSON.parse(JSON.stringify(res));
        if(this.custName == "" || this.custName == undefined){
          this.invoices=this.dubTrackObj;
        } 
       }else{
        if(this.custName == "" || this.custName == undefined){
          this.invoices=this.dubTrackObj;
        }else{
          this.invoices = [];
        }
       }      
     })
    }else{
      this.invoices=this.dubTrackObj;
    }
  }else{
    let x = val.length;
    this.close=true;
    this.id=localStorage.getItem('organizationId');
    var toDate = this.cDate+' '+'23:59:59';
    var fromDate = this.pDate+' '+'00:00:00'; 
    if(x > 0){
      this.invoices = [];     
     this.service.searchInvoiceByName(this.id,val,fromDate,toDate).subscribe((res: any) => {
       if(res != null && res != "NO_CONTENT" && res.length > 0){
        this.invoices =JSON.parse(JSON.stringify(res));
        if(this.custName == "" || this.custName == undefined){
          this.invoices=this.dubTrackObj;
        } 
       }else{
         this.invoices = [];
       }      
     })
    }else{
      this.invoices=this.dubTrackObj;
    }
  }
}
  
  getCusData(data){
    this.userData = data;   
    }

}

